import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}

import * as PIXI from "pixi.js";
window.PIXI = PIXI;

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {NolimitGameIntroPlugin} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/NolimitGameIntroPlugin";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";
import {StarStruck} from "./game/StarStruck";
import {StarStruckIntroConfig} from "./game/intro/StarStruckIntroConfig";
import {StarStruckPromoPanelConfig} from "./game/StarStruckPromoPanelConfig";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
NolimitLauncher.instance.launch([
    new StarStruck(),
    new SlotKeypad(),
    new NolimitPromotionPlugin(new StarStruckPromoPanelConfig()),
    new NolimitGameIntroPlugin(new StarStruckIntroConfig),
    new NolimitSlotAudio()
]);